import {defineStore } from 'pinia';
import apiClient from '@/api/apiClient';

export const useUserStore = defineStore('user', {
    state: () => ({ 
        user_id: null,
        user_info:{},
        sucursal_sponsored: {},
    }),
    actions: {
        setUid(uid) {
            this.user_id = uid;
            this.getInfoUser();
        },
        getUid() {
            return this.user_id;
        },
        setUserInfo(user_info){
            this.user_info = user_info;
        },
        setInforSucursalSponsored(sucursal_sponsored){
            this.sucursal_sponsored = sucursal_sponsored;
        },
        async getInfoUser(){

            const user = await apiClient.get('/user/get-perfil/'+this.user_id);

            if(user.data.ok){
                this.setUserInfo(user.data.data);
                this.getInfoSucursalSponsored();
            }else{
                this.setUserInfo({});
            }
        },
        getUserInfo(){
            return this.user_info;
        },
        async getInfoSucursalSponsored(){
            await apiClient.get('sponsorship-licensing/validate-branch-is-sponsored')
            .then((response) => {
                //Valor asignado es true o false
                localStorage.setItem('sucursal_sponsored', JSON.stringify(response.data.data));
                this.setInforSucursalSponsored(response.data.data);
            })
            .catch((error) => {
                console.error('Error al validar la sucursal patrocinada:', error);
            });
        },

        getSponsored() { 
            return this.sucursal_sponsored;
        }

    },
    persist: {
        storage: localStorage,
    }
  });